import React, { Component } from 'react';
import storeIcon from "../images/lokal/mobile-store.png"
import { Link } from 'react-router-dom';
export default class HeaderStore extends Component {
    render() {
        let storeId = window.sessionStorage.getItem('storeId')
        let subDomainFlag = window.sessionStorage.getItem('subDomainFlag');
        return (
            (storeId !== null && storeId !== 'null' && storeId !== '' && subDomainFlag !== '1') ? <div className="headerIcons"><Link to={window.sessionStorage.getItem('mainCategorySeoSlug')} className="headerImage"><img title="Choose Store" src={storeIcon} alt="storeImage" /></Link></div> : ''
        )
    }
}